import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../services/api-client';
import { PlayerSchema, type Player } from '../schemas/auth.schema';
import { z } from 'zod';

const RosterSchema = z.array(PlayerSchema);

/**
 * The list of accounts that can be signed into, for someone who arrived without
 * an invite link. Deliberately not gated by a code: a returning player on a new
 * phone should not need the group chat to get back in. PIN attempts are
 * rate-limited and locked out server-side, which is what actually protects an
 * account here.
 */
export const useRosterForSignIn = () =>
    useQuery<Player[]>({
        queryKey: ['roster'],
        queryFn: () => apiClient.get('auth/players', RosterSchema),
        retry: false,
        staleTime: 30_000,
    });
